import { render, staticRenderFns } from "./SendSmsModal.vue?vue&type=template&id=8b93d042&"
import script from "./SendSmsModal.vue?vue&type=script&lang=js&"
export * from "./SendSmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b93d042')) {
      api.createRecord('8b93d042', component.options)
    } else {
      api.reload('8b93d042', component.options)
    }
    module.hot.accept("./SendSmsModal.vue?vue&type=template&id=8b93d042&", function () {
      api.rerender('8b93d042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SmsSettings/SendSmsModal.vue"
export default component.exports